import { FC } from 'react';

import SectionContainer from '@common/components/SectionContainer';
import { Routes } from '@common/constants';
import { useTranslations } from '@lang';
import { getCheapestOption } from '@utils/helpers';
import { mapDiscountToDisplayObject } from '@utils/mapDiscountToDisplayObject';
import { useRouter } from 'shared-routing';
import { Product } from 'shared-types/Product';
import { cardAspectRatio, ProductListItem, ProductListTemplate } from 'voyager';

import { ProductsV2Props } from './ProductsV2.types';

export const ProductsV2: FC<ProductsV2Props> = ({ property, products }) => {
  const { t } = useTranslations();
  const router = useRouter();

  const formatDuration = ({ duration, durationText }: Product): string | undefined => {
    if (duration) return t('spa.minutesIndicator', { number: duration });
    if (durationText) return t(durationText);
    return undefined;
  };

  const items: ProductListItem[] = products.map((product) => {
    const options = product.options ?? [];

    return {
      id: String(product.id),
      name: product.name,
      imageUrl: product.imageGallery?.length ? product.imageGallery[0]?.url : product.image?.url,
      price:
        product.price?.amount != null
          ? { amount: product.price.amount, currencyCode: product.price.currencyCode }
          : undefined,
      discount: mapDiscountToDisplayObject(product.discount),
      promotionName: product.discount?.name,
      duration: formatDuration(product),
      optionName: options.length > 0 ? getCheapestOption(options).name : undefined,
      unavailable: product.unAvailable,
    };
  });

  const handleSelectProduct = (id: string) => {
    router.push({ pathname: Routes.PRODUCT_DETAIL, query: { id } });
  };

  return (
    <SectionContainer>
      <ProductListTemplate
        items={items}
        onSelectItem={handleSelectProduct}
        imageAspectRatio={cardAspectRatio.square.desktop}
        imageMobileAspectRatio={cardAspectRatio.square.mobile}
        titleLabel={t('products.shopProperty', { property: property.name })}
        fromPriceLabel={t('common.from')}
        soldOutLabel={t('spa.soldOut')}
        noResultsLabel={t('products.noResults')}
        noImageLabel={t('spa.noImage')}
      />
    </SectionContainer>
  );
};
